import { axiosInstance } from './axiosInstance';

export const GuidelineService = {
  getAll: async (membershipId) => {
    return await axiosInstance.get(`/api/feature/membership/guideline/${membershipId}`);
  },
  getDetail: async (membershipId, guidelineDay) => {
    return await axiosInstance.get(`/api/feature/membership/guideline/${membershipId}/${guidelineDay}`);
  },
  create: async (data) => {
    return await axiosInstance.post('/api/feature/membership/guideline', data);
  },
  update: async (guidelineId, data) => {
    return await axiosInstance.post(`/api/feature/membership/guideline/update/${guidelineId}`, data);
  },
  delete: async (guidelineId) => {
    return await axiosInstance.delete(`/api/feature/membership/guideline/delete/${guidelineId}`);
  },
}